import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconSpaMinimapMarkers = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={376}
    height={375}
    fill="none"
    viewBox="0 0 376 375"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#icon-spa-minimap-markers_svg__a)">
      <path
        fill="url(#icon-spa-minimap-markers_svg__b)"
        fillOpacity={0.2}
        stroke="#fff"
        strokeOpacity={0.1}
        strokeWidth={10}
        d="M36.24 234.409c-1.096 2.578-3.244 7.571-4.249 9.668-.731 1.279-2.193 4.204-1.097 5.678 1.097 1.473 2.88.153 4.25-.614 1.094-.531 9.212-5.706 18.93-11.97a7309.346 7309.346 0 0 0 28.639-18.568l4.056-2.584c7.357-4.692 17.331-11.074 18.152-11.687 1.233-.921 1.508-1.841 3.29-1.381 2.034.526 2.147 2.404 2.056 3.376-.046.409.024 1.555-.411 3.99-.274 1.534.411 2.455 1.234 3.069.572.256 1.182.174 1.645.153 4.341-.409 14.86-1.381 22.207-1.995a75.948 75.948 0 0 0 4.689-.539c5.56-.811 10.665-2.16 14.641-3.604 3.425-1.449 8.082-3.533 14.394-6.138 4.382-1.809 10.144-3.99 13.845-5.831 7.901-3.931 15.217-.921 16.588-.154.397.222 2.894 1.477 8.91 4.45 3.427 1.842 9.014 4.019 14.12 7.213 8.416 5.264 13.488 11.355 18.095 20.563 2.895 5.785 6.306 13.043 9.322 19.795 2.565 5.743 4.701 9.998 6.992 13.504 3.391 5.191 6.873 8.739 10.555 13.044 5.638 6.591 14.12 13.504 18.096 15.652 2.926 1.582 6.854 3.376 13.982 5.985 2.434.891 5.347.46 7.951-.307 3.452-1.349 6.263-3.866 7.54-5.831 1.247-1.92 3.244-4.908 5.483-8.349a384.004 384.004 0 0 0 4.936-7.764c3.18-5.156.319-9.719-1.508-11.355a8525.02 8525.02 0 0 1-7.303-5.228c-6.927-4.963-14.704-10.552-15.728-11.346-1.782-1.381-5.317-3.375-6.58-8.133-1.263-4.757-.137-8.286 1.097-10.588.796-1.485 1.508-2.302 2.604-4.757 1.097-2.455 1.177-3.372 1.234-6.138.109-5.225-3.427-9.515-6.717-11.356-2.832-1.286-6.343-2.88-10.145-4.604-13.434-6.092-30.492-13.814-33.997-15.345-5.62-2.455-10.281-8.133-12.475-14.118-2.193-5.985-1.645-9.821-1.233-16.88.172-2.965.267-3.495.644-5.603l.041-.228c.823-3.223 1.508-4.45 3.564-6.905 1.71-2.041 4.076-3.666 6.443-4.604 3.702-.921 6.792-1.546 9.596-1.995 4.798-.767 15.616-3.465 25.224-5.064 10.145-1.688 29.441-9.623 33.038-10.895 2.605-.921 5.62.614 7.265 2.608.635.995 1.44 2.366 2.3 3.88a416.54 416.54 0 0 1 3.047 5.481c2.741 4.757 3.836 7.301 5.346 9.668 3.427 5.371 8.362 3.836 9.87 2.915 1.508-.92 3.104-2.009 3.976-5.524.685-2.762-.274-5.575-1.097-6.752l-4.96-7.987c-7.8-12.568-18.274-29.459-20.401-32.831-2.632-4.175-6.763-4.502-8.499-4.144a2122.247 2122.247 0 0 0-10.004 2.784c-1.369.386-2.652.75-3.705 1.053-4.798 1.38-7.814-2.763-8.499-4.144-.685-1.381-1.371-3.222-3.564-4.91-1.755-1.35-4.204-1.279-5.21-1.074l-29.199 9.353c-33.56 10.752-73.445 23.537-78.002 25.02-6.031 1.965-11.286 4.706-13.16 5.832-7.768 5.473-24.237 17.125-27.965 19.949-4.661 3.529-8.226 5.831-10.282 6.291-1.155.259-4.433.887-6.306 1.074-1.461.146-3.016.154-6.306 1.688-3.854 1.799-6.042 3.518-7.95 6.138a48.413 48.413 0 0 0-1.929 3.038c-1.25 2.134-2.127 3.967-2.733 5.096-1.316 2.455-2.741 3.533-3.7 4.45-1.874 1.79-6.334 6.138-10.282 9.821-4.935 4.603-22.208 20.409-29.61 29.77-4.003 5.06-7.684 11.825-10.438 17.481-2.341 4.807-4.013 8.814-4.642 10.294Z"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M325.082 273.233a388.535 388.535 0 0 1-4.935 7.764c-2.24 3.441-4.237 6.429-5.484 8.349"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M323.571 261.878c1.828 1.637 4.689 6.199 1.508 11.355"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M323.571 261.878c-1.996-1.428-4.584-3.28-7.302-5.228"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M300.542 245.305c1.024.793 8.801 6.382 15.728 11.345"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M300.542 245.305c-1.782-1.382-5.316-3.376-6.58-8.134-1.263-4.757-.137-8.286 1.097-10.588.796-1.485 1.508-2.302 2.605-4.757"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M298.899 215.688c-.058 2.766-.137 3.683-1.234 6.138"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M292.178 204.332c3.29 1.842 6.826 6.131 6.717 11.356"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M292.18 204.332c-2.832-1.286-6.343-2.88-10.145-4.604"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M234.329 153.385c-.411 7.059-.96 10.896 1.234 16.88 2.193 5.985 6.854 11.663 12.474 14.118 3.505 1.531 20.563 9.253 33.997 15.346"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M234.33 153.385c.179-3.069.274-3.529.685-5.831.823-3.223 1.508-4.45 3.565-6.905 1.709-2.041 4.076-3.666 6.443-4.604"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M254.618 134.05c-2.804.449-5.894 1.074-9.596 1.995"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M312.882 118.091c-3.597 1.272-22.894 9.207-33.038 10.895-9.608 1.599-20.426 4.297-25.224 5.064"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M312.88 118.091c2.605-.921 5.62.613 7.265 2.608.635.995 1.44 2.366 2.3 3.88"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M325.492 130.06a416.54 416.54 0 0 0-3.047-5.481"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M330.838 139.728c-1.511-2.367-2.605-4.911-5.347-9.668"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M340.707 142.644c-1.508.92-6.443 2.455-9.87-2.916"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M344.685 137.119c-.872 3.515-2.467 4.604-3.975 5.524"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M344.684 137.119c.686-2.762-.274-5.575-1.096-6.752-1.404-2.259-3.107-5.001-4.96-7.987"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M318.226 89.549c2.126 3.372 12.6 20.263 20.401 32.831"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M309.729 85.405c1.736-.358 5.867-.03 8.499 4.144"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M309.727 85.405a2122.247 2122.247 0 0 0-10.004 2.785"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M287.519 85.098c.685 1.381 3.701 5.525 8.499 4.144 1.052-.303 2.335-.667 3.704-1.053"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M278.747 79.114c1.005-.205 3.455-.277 5.209 1.074 2.194 1.688 2.879 3.529 3.565 4.91"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="m278.744 79.114-29.199 9.353"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M120.136 145.559c2.056-.46 5.62-2.762 10.281-6.291 3.729-2.824 20.197-14.476 27.966-19.949 1.873-1.126 7.128-3.867 13.16-5.832 4.556-1.483 44.442-14.268 78.002-25.02"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M120.138 145.559c-1.155.259-4.433.887-6.306 1.074-1.461.146-3.016.154-6.306 1.688-3.854 1.799-6.042 3.518-7.95 6.138a48.46 48.46 0 0 0-1.928 3.038"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M40.88 224.115c2.755-5.656 6.437-12.421 10.438-17.481 7.403-9.361 24.676-25.167 29.611-29.77 3.948-3.683 8.408-8.031 10.281-9.821.96-.917 2.386-1.995 3.702-4.45.605-1.129 1.483-2.962 2.733-5.096"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M31.993 244.077c1.006-2.097 3.153-7.09 4.25-9.668.63-1.48 2.3-5.487 4.642-10.294"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M35.144 249.141c-1.37.767-3.153 2.087-4.25.614-1.096-1.474.366-4.399 1.097-5.678"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M35.144 249.141c1.093-.531 9.212-5.707 18.93-11.97"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M54.074 237.171a7418.653 7418.653 0 0 0 28.639-18.568c1.179-.75 2.564-1.632 4.056-2.584"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M104.923 204.332c-.821.612-10.795 6.995-18.153 11.687"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M104.922 204.332c1.234-.921 1.508-1.842 3.29-1.381 2.034.525 2.148 2.404 2.056 3.376-.045.409.024 1.555-.411 3.99-.274 1.534.411 2.455 1.234 3.069"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M111.091 213.386c.572.256 1.182.174 1.645.153 4.341-.409 14.86-1.381 22.208-1.994a76.78 76.78 0 0 0 4.688-.54"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M314.662 289.346c-1.277 1.965-4.088 4.482-7.54 5.831-2.605.767-5.517 1.198-7.951.307-7.128-2.609-11.056-4.403-13.983-5.985-3.975-2.148-12.457-9.061-18.095-15.652-3.682-4.305-7.164-7.853-10.556-13.044-2.291-3.506-4.426-7.761-6.991-13.504-3.016-6.752-6.427-14.01-9.322-19.795-4.607-9.208-9.679-15.299-18.095-20.563-5.106-3.194-10.693-5.371-14.12-7.213-6.016-2.973-8.514-4.228-8.911-4.45-1.37-.767-8.686-3.777-16.587.154-3.701 1.841-9.464 4.022-13.846 5.831-6.311 2.605-10.968 4.689-14.394 6.138-3.976 1.444-9.08 2.793-14.64 3.604"
      />
      <g filter="url(#icon-spa-minimap-markers_svg__c)">
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="m63.285 206.841 3.54-1.92 2.159 3.978-3.541 1.92zM67.601 214.798l3.54-1.92 2.159 3.978-3.541 1.92zM71.916 222.754l3.54-1.92 2.159 3.978-3.541 1.92zM76.231 230.711l3.54-1.92 2.159 3.978-3.541 1.92zM80.547 238.667l3.54-1.92 2.159 3.978-3.541 1.92zM68.983 208.9l3.54-1.921 2.159 3.978-3.541 1.92z"
        />
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="m73.299 216.855 3.54-1.92 2.159 3.978-3.541 1.92zM77.614 224.812l3.54-1.92 2.159 3.978-3.541 1.92zM81.931 232.769l3.54-1.92 2.159 3.978-3.541 1.92z"
        />
        <path
          fill="#000"
          d="m66.826 204.921 3.54-1.92 2.159 3.978-3.541 1.92zM71.142 212.877l3.54-1.92 2.159 3.978-3.541 1.92zM75.457 220.834l3.54-1.92 2.159 3.978-3.541 1.92zM79.772 228.79l3.54-1.92 2.159 3.978-3.541 1.92zM84.088 236.747l3.54-1.92 2.159 3.978-3.541 1.92z"
        />
        <path
          fill="#000"
          d="m65.443 210.82 3.54-1.921 2.159 3.978-3.541 1.92zM69.759 218.776l3.54-1.92 2.159 3.978-3.541 1.92zM74.074 226.732l3.54-1.92 2.159 3.978-3.541 1.92zM78.39 234.689l3.54-1.92 2.159 3.978-3.541 1.92z"
        />
        <path
          fill="#E2645A"
          d="m62.603 259.976 17.726 1.598-9.421-17.37-8.305 15.772Zm-1.99 1.079c-.347-.64-.408-1.38-.068-2.007l8.735-16.502c.657-1.296 2.434-1.155 3.198.254l9.908 18.266c.74 1.366-.087 2.975-1.509 2.862l-18.619-1.721a2.208 2.208 0 0 1-1.645-1.152Z"
        />
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__d)">
        <rect
          width={20}
          height={20}
          x={26.5}
          y={259}
          fill="url(#icon-spa-minimap-markers_svg__e)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__f)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m36.327 266.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__g)">
        <rect
          width={20}
          height={20}
          x={26.5}
          y={186}
          fill="url(#icon-spa-minimap-markers_svg__h)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__i)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m33.505 198.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V200h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__j)">
        <rect
          width={20}
          height={20}
          x={67.5}
          y={144}
          fill="url(#icon-spa-minimap-markers_svg__k)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__l)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M74.287 156.764v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L79.05 158h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__m)">
        <rect
          width={20}
          height={20}
          x={90.5}
          y={123}
          fill="url(#icon-spa-minimap-markers_svg__n)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__o)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M101.207 135.392h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V137h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__p)">
        <rect
          width={20}
          height={20}
          x={115.5}
          y={113}
          fill="url(#icon-spa-minimap-markers_svg__q)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__r)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M122.389 125.764v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996V118.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L127.129 127h-3.504l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__s)">
        <rect
          width={20}
          height={20}
          x={157.5}
          y={92}
          fill="url(#icon-spa-minimap-markers_svg__t)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__u)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M164.409 104.764v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L169.221 106h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__v)">
        <rect
          width={20}
          height={20}
          x={258.5}
          y={92}
          fill="url(#icon-spa-minimap-markers_svg__w)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__x)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M269.661 99.028V98.8h-4.248v-1.2h5.688v1.464L267.753 106h-1.464l3.372-6.972Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__y)">
        <rect
          width={20}
          height={20}
          x={282.5}
          y={97}
          fill="url(#icon-spa-minimap-markers_svg__z)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__A)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M289.256 109.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L294.26 111h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__B)">
        <rect
          width={20}
          height={20}
          x={308.5}
          y={60}
          fill="url(#icon-spa-minimap-markers_svg__C)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__D)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M315.44 72.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L320.132 74h-3.456l-1.236-1.236Zm3.648-3.072.888-.888V67.28l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__E)">
        <rect
          width={20}
          height={20}
          x={331.5}
          y={151}
          fill="url(#icon-spa-minimap-markers_svg__F)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__G)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m337.341 158.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L345.559 165h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__H)">
        <rect
          width={20}
          height={20}
          x={299.5}
          y={131}
          fill="url(#icon-spa-minimap-markers_svg__I)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__J)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m306.958 138.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.738 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__K)">
        <rect
          width={20}
          height={20}
          x={209.5}
          y={135}
          fill="url(#icon-spa-minimap-markers_svg__L)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__M)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m215.803 142.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V149h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__N)">
        <rect
          width={20}
          height={20}
          x={248.5}
          y={57}
          fill="url(#icon-spa-minimap-markers_svg__O)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__P)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m254.803 64.076-1.836.948V63.74l2.076-1.14h1.152V71h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V71h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__Q)">
        <rect
          width={20}
          height={20}
          x={299.5}
          y={186}
          fill="url(#icon-spa-minimap-markers_svg__R)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__S)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m305.634 193.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L313.42 200h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__T)">
        <rect
          width={20}
          height={20}
          x={265.5}
          y={225}
          fill="url(#icon-spa-minimap-markers_svg__U)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__V)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m271.774 232.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.802 5.316h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V239h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__W)">
        <rect
          width={20}
          height={20}
          x={322.5}
          y={234}
          fill="url(#icon-spa-minimap-markers_svg__X)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__Y)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m328.616 241.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.142 5.688v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996V239.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L336.498 248h-3.504l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__Z)">
        <rect
          width={20}
          height={20}
          x={289.5}
          y={262}
          fill="url(#icon-spa-minimap-markers_svg__aa)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__ab)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m295.516 269.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.263 5.688v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L303.591 276h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__ac)">
        <rect
          width={20}
          height={20}
          x={233.5}
          y={193}
          fill="url(#icon-spa-minimap-markers_svg__ad)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__ae)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m240.12 200.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.91-.048v-.228h-4.248v-1.2h5.688v1.464L245.122 207h-1.464l3.372-6.972Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__af)">
        <rect
          width={20}
          height={20}
          x={173.5}
          y={167}
          fill="url(#icon-spa-minimap-markers_svg__ag)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__ah)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m179.423 174.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.202 5.688v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L187.629 181h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__ai)">
        <rect
          width={20}
          height={20}
          x={111.5}
          y={221}
          fill="url(#icon-spa-minimap-markers_svg__aj)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__ak)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m117.487 228.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.322 5.688v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L125.501 235h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
          />
        </g>
      </g>
      <g filter="url(#icon-spa-minimap-markers_svg__al)">
        <rect
          width={20}
          height={20}
          x={111.5}
          y={177}
          fill="url(#icon-spa-minimap-markers_svg__am)"
          rx={10}
        />
        <g filter="url(#icon-spa-minimap-markers_svg__an)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m114.518 189.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V191h-5.784v-1.764Zm7.239.432v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L126.713 191h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="icon-spa-minimap-markers_svg__c"
        width={81.917}
        height={91.002}
        x={27.5}
        y={196}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={3}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__d"
        width={36}
        height={36}
        x={18.5}
        y={253}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__f"
        width={19.227}
        height={24.4}
        x={26.491}
        y={258.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__g"
        width={36}
        height={36}
        x={18.5}
        y={180}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__i"
        width={21.831}
        height={24.4}
        x={25.457}
        y={185.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__j"
        width={36}
        height={36}
        x={59.5}
        y={138}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__l"
        width={22}
        height={24.4}
        x={66.287}
        y={143.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__m"
        width={36}
        height={36}
        x={82.5}
        y={117}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__o"
        width={22.492}
        height={24.4}
        x={89.127}
        y={122.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__p"
        width={36}
        height={36}
        x={107.5}
        y={107}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__r"
        width={21.977}
        height={24.4}
        x={114.389}
        y={112.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__s"
        width={36}
        height={36}
        x={149.5}
        y={86}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__u"
        width={22.048}
        height={24.4}
        x={156.409}
        y={91.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__v"
        width={36}
        height={36}
        x={250.5}
        y={86}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__x"
        width={21.688}
        height={24.4}
        x={257.413}
        y={91.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__y"
        width={36}
        height={36}
        x={274.5}
        y={91}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__A"
        width={22.24}
        height={24.4}
        x={281.256}
        y={96.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__B"
        width={36}
        height={36}
        x={300.5}
        y={54}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__D"
        width={22.048}
        height={24.4}
        x={307.32}
        y={59.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__E"
        width={36}
        height={36}
        x={323.5}
        y={145}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__G"
        width={27.386}
        height={24.4}
        x={327.505}
        y={150.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__H"
        width={36}
        height={36}
        x={291.5}
        y={125}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__J"
        width={23.966}
        height={24.4}
        x={297.122}
        y={130.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__K"
        width={36}
        height={36}
        x={201.5}
        y={129}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__M"
        width={26.689}
        height={24.4}
        x={205.968}
        y={134.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__N"
        width={36}
        height={36}
        x={240.5}
        y={51}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__P"
        width={26.689}
        height={24.4}
        x={244.968}
        y={56.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__Q"
        width={36}
        height={36}
        x={291.5}
        y={180}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__S"
        width={26.858}
        height={24.4}
        x={295.798}
        y={185.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__T"
        width={36}
        height={36}
        x={257.5}
        y={219}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__V"
        width={27.05}
        height={24.4}
        x={261.938}
        y={224.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__W"
        width={36}
        height={36}
        x={314.5}
        y={228}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__Y"
        width={26.954}
        height={24.4}
        x={318.78}
        y={233.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__Z"
        width={36}
        height={36}
        x={281.5}
        y={256}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__ab"
        width={27.145}
        height={24.4}
        x={285.681}
        y={261.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__ac"
        width={36}
        height={36}
        x={225.5}
        y={187}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__ae"
        width={26.186}
        height={24.4}
        x={230.284}
        y={192.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__af"
        width={36}
        height={36}
        x={165.5}
        y={161}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__ah"
        width={27.278}
        height={24.4}
        x={169.587}
        y={166.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__ai"
        width={36}
        height={36}
        x={103.5}
        y={215}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__ak"
        width={27.086}
        height={24.4}
        x={107.651}
        y={220.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__al"
        width={36}
        height={36}
        x={103.5}
        y={171}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <filter
        id="icon-spa-minimap-markers_svg__an"
        width={29.574}
        height={24.4}
        x={106.471}
        y={176.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_13463"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_13463"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_13463"
          result="effect2_dropShadow_9632_13463"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_13463"
          result="shape"
        />
      </filter>
      <linearGradient
        id="icon-spa-minimap-markers_svg__b"
        x1={189.235}
        x2={189.235}
        y1={295.982}
        y2={79}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4FC5BA" />
        <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__e"
        x1={46.5}
        x2={26.5}
        y1={259}
        y2={279}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__h"
        x1={46.5}
        x2={26.5}
        y1={186}
        y2={206}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__k"
        x1={87.5}
        x2={67.5}
        y1={144}
        y2={164}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__n"
        x1={110.5}
        x2={90.5}
        y1={123}
        y2={143}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__q"
        x1={135.5}
        x2={115.5}
        y1={113}
        y2={133}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__t"
        x1={177.5}
        x2={157.5}
        y1={92}
        y2={112}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__w"
        x1={278.5}
        x2={258.5}
        y1={92}
        y2={112}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__z"
        x1={302.5}
        x2={282.5}
        y1={97}
        y2={117}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__C"
        x1={328.5}
        x2={308.5}
        y1={60}
        y2={80}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__F"
        x1={351.5}
        x2={331.5}
        y1={151}
        y2={171}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__I"
        x1={319.5}
        x2={299.5}
        y1={131}
        y2={151}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__L"
        x1={229.5}
        x2={209.5}
        y1={135}
        y2={155}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__O"
        x1={268.5}
        x2={248.5}
        y1={57}
        y2={77}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__R"
        x1={319.5}
        x2={299.5}
        y1={186}
        y2={206}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__U"
        x1={285.5}
        x2={265.5}
        y1={225}
        y2={245}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__X"
        x1={342.5}
        x2={322.5}
        y1={234}
        y2={254}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__aa"
        x1={309.5}
        x2={289.5}
        y1={262}
        y2={282}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__ad"
        x1={253.5}
        x2={233.5}
        y1={193}
        y2={213}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__ag"
        x1={193.5}
        x2={173.5}
        y1={167}
        y2={187}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__aj"
        x1={131.5}
        x2={111.5}
        y1={221}
        y2={241}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-spa-minimap-markers_svg__am"
        x1={131.5}
        x2={111.5}
        y1={177}
        y2={197}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <clipPath id="icon-spa-minimap-markers_svg__a">
        <path fill="#fff" d="M.5 0h375v375H.5z" />
      </clipPath>
    </defs>
  </svg>
));
export default SvgIconSpaMinimapMarkers;
